import React from "react";

const QuestionsManager = () => {
    return (
        <div>
            <h1>Questions Manager</h1>
        </div>
    );
};

export default QuestionsManager;